import { render, staticRenderFns } from "./EmbeddedBaseForm.vue?vue&type=template&id=7e813a52&scoped=true&"
import script from "./EmbeddedBaseForm.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedBaseForm.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedBaseForm.vue?vue&type=style&index=0&id=7e813a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e813a52",
  null
  
)

export default component.exports